import { Component, ElementRef, EventEmitter, OnInit, Output, inject } from "@angular/core";
import { catchError, finalize, map, tap, throwError, of} from "rxjs";
import { BreadcrumbDataService } from "../../../main/layout/tool-bar/breadcrumb-service/breadcrumb-data.service";
import { IBreadcrumbItem } from "../../../main/layout/tool-bar/model/breadcrumb.model";
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IPackageAccess } from "../models/package-access.model";
import { AppSettingsService, SpinnerService } from "../../../core";
import { HttpErrorResponse } from "@angular/common/http";
import { MessageService } from "../../../main";
import { IBucketItem } from "../../bucket-items/models/bucket-item.model";
import { DataService } from "../../bucket-items/service/data.service";
import { RequesterAccessService } from "../service/requester-access.service";
import { CommonConsants, ErrorConstants } from "../../bucket-items/constants/component-constants";
import { IActivePermissionHoldersRequest } from "../models/active-permision-holders-request.model";
import { IActivePermissionHoldersResponse } from "../models/active-permission-holders-response.model";
import { IRevokeAccessRequest } from "../models/revoke-active-permission-request.model";
import { DeletePopupComponent } from "../../bucket-items/delete-popup/delete-popup.component";
import { MatDialog } from "@angular/material/dialog";
import { IUserInfoResponse } from "../models/get-user-info-response.model";
import { AutoComplete } from "../../../shared/models/material-common-models";
import { MasterDataService } from "../../../dynamic-controls/master-data-service";
import { IUserInformation } from "../../../shared/user-information-overlay/user-information";
import { GenericExtensionsService } from "../../../extensions/generic-extensions-service";
import { NgClass, DatePipe } from "@angular/common";
import { MatTooltip } from "@angular/material/tooltip";
import { AutoCompleteComponent } from "../../../shared/autocomplete/autocomplete.component";
import { MatError, MatFormField, MatLabel, MatInput, MatHint } from "@angular/material/input";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/autocomplete";
import { MatButton, MatIconButton } from "@angular/material/button";

@Component({
    selector: "app-folder-permission",
    templateUrl: "./folder-permission.component.html",
    styleUrls: ["./folder-permission.component.scss"],
    imports: [NgClass, MatTooltip, FormsModule, ReactiveFormsModule, AutoCompleteComponent, MatError, MatFormField, MatLabel, MatSelect, MatOption, MatInput, MatHint, MatButton, MatIconButton, DatePipe]
})

export class FolderPermissionComponent implements OnInit {
  private breadcrumbDataService = inject(BreadcrumbDataService);
  private dataService = inject(DataService);
  private requesterAccessService = inject(RequesterAccessService);
  private masterDataService = inject(MasterDataService);
  private spinnerService = inject(SpinnerService);
  private messageService = inject(MessageService);
  private appSettingService = inject(AppSettingsService);
  private dialog = inject(MatDialog);
  private el = inject(ElementRef);
  private genericExtensions = inject(GenericExtensionsService);

  public currentBreadcrumbItem: IBreadcrumbItem = null;
  public packagefolder: Partial<IBucketItem> = {};
  public static RequesterPuid: string="";
  public requesterUserInfo: AutoComplete[]=[];
  public glpManagerUserInfo: AutoComplete[]=[];
  public autoCompleteId:number=1;
  public userFieldOnFocus: boolean = false;
  public glpManagerFieldOnFocus: boolean = false;
  public prePopulate: boolean = false;
  public reqPuid: string = "";
  public glpPuid: string = "";
  public valuesPrePopulated: boolean = false;
  public scrollable:boolean = true;
  public durationValues: {id:number,displaytext:string}[] = [
                                                              {id:1,displaytext:"1 Hour"},
                                                              {id:2,displaytext:"2 Hours"},
                                                              {id:3,displaytext:"3 Hours"},
                                                              {id:4,displaytext:"4 Hours"},
                                                              {id:5,displaytext:"5 Hours"},
                                                              {id:6,displaytext:"6 Hours"},
                                                              {id:7,displaytext:"7 Hours"},
                                                              {id:24,displaytext:"1 Day"},
                                                              {id:48,displaytext:"2 Days"},
                                                              {id:72,displaytext:"3 Days"},
                                                              {id:96,displaytext:"4 Days"},
                                                              {id:120,displaytext:"5 Days"},
                                                              {id:144,displaytext:"6 Days"},
                                                              {id:168,displaytext:"7 Days"}
                                                            ];
  public requestData: IPackageAccess=null;
  public activePermissionHolders:{activePermissionHoldersResponse:IActivePermissionHoldersResponse,showRevokeAccess:boolean}[] =[];
  @Output() accessGiven = new EventEmitter<boolean>();

  folderPermissionForm = new FormGroup({
    RequesterPuid: new FormControl(null, [
      Validators.required
    ]),
    GLPManagerPuid: new FormControl(null, [
      Validators.required
    ]),
    Duration: new FormControl(null,[
      Validators.required
    ]),
    Justification: new FormControl(null, [
      Validators.required,
      Validators.minLength(10),
    ]),
  });

  ngOnInit(): void {
    this.breadcrumbDataService.selectedBreadcrumb$
      .pipe(
        tap((item: IBreadcrumbItem) => {
          this.currentBreadcrumbItem = item;
        })
      )
      .subscribe();
    this.dataService
    .getAllSelectedData()
    .subscribe((data: Partial<IBucketItem>[]) => {
      if (data.length !== 0) {
        this.packagefolder = [...data][0];
      }
    });
    this.getActivePermissionHolders({PackageId:this.packagefolder.PackageId,BucketItemId:this.packagefolder.Id,BucketType:this.currentBreadcrumbItem.BucketType,BUCode:this.currentBreadcrumbItem.BUCode});
    this.folderPermissionForm.get('RequesterPuid').valueChanges.subscribe(() => {
      this.setErrors();
    });
    this.folderPermissionForm.get('GLPManagerPuid').valueChanges.subscribe(() => {
      this.setErrors();
    });
    this.dataService
      .getAutoCompleteActiveStatus()
      .subscribe((status: boolean) => {
          this.scrollable = !status;
      });
  }

  public setErrors(){
    const pattern = new RegExp('^[a-zA-Z0-9]{3,4}$',"g");
    if(!this.userFieldOnFocus && !this.glpManagerFieldOnFocus && 
          (
             (pattern.test(this.folderPermissionForm.controls.RequesterPuid.value)) || 
              this.requesterUserInfo.find(x=>x.DisplayTextForSelectedValue.toLowerCase()===this.folderPermissionForm.controls.RequesterPuid.value.toLowerCase())?.SelectedValue?.length>=3 || 
               (pattern.test(this.folderPermissionForm.controls.GLPManagerPuid.value)) 
          ) 
        && this.folderPermissionForm.controls.RequesterPuid.value?.length>=3 
        && this.folderPermissionForm.controls.GLPManagerPuid.value?.length>=3 
        && this.folderPermissionForm?.controls?.RequesterPuid?.value?.toUpperCase()===this.folderPermissionForm?.controls?.GLPManagerPuid?.value?.toUpperCase()){
      this.folderPermissionForm.controls.RequesterPuid.markAsTouched();
      this.folderPermissionForm.controls.GLPManagerPuid.markAsTouched();
      this.folderPermissionForm.controls.RequesterPuid.setErrors({ SamePuid: true });
      this.folderPermissionForm.controls.GLPManagerPuid.setErrors({ SamePuid: true });
    }
    else{
      if (this.folderPermissionForm.controls.RequesterPuid.errors && this.folderPermissionForm.controls.RequesterPuid.errors?.SamePuid) {
        delete this.folderPermissionForm.controls.RequesterPuid.errors.SamePuid;
        this.folderPermissionForm.controls.RequesterPuid.setErrors(Object.keys(this.folderPermissionForm.controls.RequesterPuid.errors).length !== 0 ? this.folderPermissionForm.controls.RequesterPuid.errors : null);
      }
      if (this.folderPermissionForm.controls.GLPManagerPuid.errors && this.folderPermissionForm.controls.GLPManagerPuid.errors?.SamePuid) {
        delete this.folderPermissionForm.controls.GLPManagerPuid.errors.SamePuid;
        this.folderPermissionForm.controls.GLPManagerPuid.setErrors(Object.keys(this.folderPermissionForm.controls.GLPManagerPuid.errors).length !== 0 ? this.folderPermissionForm.controls.GLPManagerPuid.errors : null);
      }
    }
  }

  public getActivePermissionHolders(activePermissionHoldersRequest: IActivePermissionHoldersRequest) {
    this.requesterAccessService
      .GetActivePermissionHolders(activePermissionHoldersRequest)
      .pipe(
        map((response: IActivePermissionHoldersResponse[]) => {
          this.activePermissionHolders=[];
          for(let i=0;i<response.length;i++){
            this.activePermissionHolders.push({activePermissionHoldersResponse:[...response][i],showRevokeAccess:false});
          }
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error.message);
        })
      )
      .subscribe();
  }

  PrePopulate(activePermissionHolder:IActivePermissionHoldersResponse){
    this.prePopulate = true;
    this.valuesPrePopulated = false;
    this.reqPuid = activePermissionHolder.RequesterPUID;
    this.glpPuid = activePermissionHolder.GLPManagerPUID;
    this.autoCompleteId = 1;
    this.getUserInfoResults(this.reqPuid);
    this.folderPermissionForm.patchValue({Duration:activePermissionHolder.Hours});
    this.folderPermissionForm.get('Justification').setValue(activePermissionHolder.Justification);
  }

  confirmRevokeAccess(activePermissionHolder:IActivePermissionHoldersResponse){
    FolderPermissionComponent.RequesterPuid=activePermissionHolder.RequesterPUID.toUpperCase();
    let dialogRef = this.dialog.open(DeletePopupComponent, {
      width: "529px",
      maxHeight: "500px",
      disableClose: true,
      data: null,
    });
    dialogRef.afterClosed().subscribe((result:boolean) => {
      if (result) {
        this.revokeAccess(activePermissionHolder);
      }
    });
  }

  revokeAccess(activePermissionHolder:IActivePermissionHoldersResponse){
    let revokeAccessRequest:IRevokeAccessRequest={Id:activePermissionHolder.Id,BucketItemId:activePermissionHolder.BucketItemId,
                                                  BucketType:this.currentBreadcrumbItem.BucketType,BUCode:this.currentBreadcrumbItem.BUCode,
                                                  PackageId:activePermissionHolder.PackageId};
    this.spinnerService.show(true);
    this.requesterAccessService
    .RevokeAccess(revokeAccessRequest)
    .pipe(
      map((res: boolean) => {
        if(res){
          this.getActivePermissionHolders({PackageId:this.packagefolder.PackageId,BucketItemId:this.packagefolder.Id,BucketType:this.currentBreadcrumbItem.BucketType,BUCode:this.currentBreadcrumbItem.BUCode});
          this.messageService.success(
          CommonConsants.PACKAGE_ACCESS_REVOKED,
          this.appSettingService.toastrDisplayTime
          );
        }
        else {
          this.messageService.alert(
            ErrorConstants.REVOKE_PACKAGE_ACCESS_FAILED,
          this.appSettingService.toastrDisplayTime
          );
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.error.detail !== undefined) {
        this.messageService.alert(
        error.error.detail,
        this.appSettingService.toastrDisplayTime
        );
        } else {
        this.messageService.alert(
        ErrorConstants.REVOKE_PACKAGE_ACCESS_FAILED,
        this.appSettingService.toastrDisplayTime
        );
        }
        return throwError(() => new Error(error.message));
      }),
      finalize(()=>{
        this.spinnerService.show(false);
      })
    )
    .subscribe();
  }

  public getUserInfo(event:string){
      if(event?.length>2 && !this.prePopulate){
          this.getUserInfoResults(event);
      }
  }

  public getUserInfoResults(value:string){
    this.masterDataService
    .GetUserInfo(value)
    .pipe(
      map((res: IUserInfoResponse[]) => {
        if(res){
          let userInfos:AutoComplete[]=[];
          for(let i=0;i<res.length;i++){
             let userInfo: AutoComplete = {Id:i,DisplayTextForSelectedValue:res[i].Name,SelectedValue:res[i].PUID,SuggestionText:res[i].UserInfo};
             userInfos.push(userInfo);
          }
          if(this.prePopulate){
            if(!this.valuesPrePopulated){
              if(this.autoCompleteId===1){
                let user = userInfos.find(x=>x.SelectedValue.toUpperCase()===this.reqPuid.toUpperCase());
                this.reqPuid = user!==undefined?user.DisplayTextForSelectedValue:this.reqPuid;
                this.requesterUserInfo = [...userInfos.sort((a, b) => a.DisplayTextForSelectedValue.localeCompare(b.DisplayTextForSelectedValue))];
                this.folderPermissionForm.get('RequesterPuid').setValue(this.reqPuid);
                this.autoCompleteId = 2;
                this.getUserInfoResults(this.glpPuid);
              }
              else{
                let user = userInfos.find(x=>x.SelectedValue.toUpperCase()===this.glpPuid.toUpperCase());
                this.glpPuid = user!==undefined?user.DisplayTextForSelectedValue:this.glpPuid;
                this.glpManagerUserInfo = [...userInfos.sort((a, b) => a.DisplayTextForSelectedValue.localeCompare(b.DisplayTextForSelectedValue))];
                this.folderPermissionForm.get('GLPManagerPuid').setValue(this.glpPuid);
                this.valuesPrePopulated = true;
              }
            }
          }
          else if(this.autoCompleteId===1){
            this.requesterUserInfo = [...userInfos.sort((a, b) => a.DisplayTextForSelectedValue.localeCompare(b.DisplayTextForSelectedValue))];
          }
          else{
            this.glpManagerUserInfo = [...userInfos.sort((a, b) => a.DisplayTextForSelectedValue.localeCompare(b.DisplayTextForSelectedValue))];
          }
        }
        else{
          if(this.autoCompleteId===1){
            this.requesterUserInfo = [...[]];
          }
          else{
            this.glpManagerUserInfo = [...[]];
          }
        }
      }),
      catchError(() => {
        if(this.autoCompleteId===1){
          this.requesterUserInfo = [...[]];
        }
        else{
          this.glpManagerUserInfo = [...[]];
        }        
        return of([]);
      })
    )
    .subscribe();
  }

  onSubmit(){
    this.folderPermissionForm.controls.RequesterPuid.markAsTouched();
    this.folderPermissionForm.controls.GLPManagerPuid.markAsTouched();
    if(this.folderPermissionForm.valid){
      let requesterPuid = this.folderPermissionForm.controls.RequesterPuid.value;
      let glpManagerPuid = this.folderPermissionForm.controls.GLPManagerPuid.value;

      if(this.requesterUserInfo.find(x=>x.DisplayTextForSelectedValue.toLowerCase()===this.folderPermissionForm.controls.RequesterPuid.value.toLowerCase())){
         requesterPuid = this.requesterUserInfo.find(x=>x.DisplayTextForSelectedValue.toLowerCase()===this.folderPermissionForm.controls.RequesterPuid.value.toLowerCase()).SelectedValue;
      }

      if(this.glpManagerUserInfo.find(x=>x.DisplayTextForSelectedValue.toLowerCase()===this.folderPermissionForm.controls.GLPManagerPuid.value.toLowerCase())){
        glpManagerPuid = this.glpManagerUserInfo.find(x=>x.DisplayTextForSelectedValue.toLowerCase()===this.folderPermissionForm.controls.GLPManagerPuid.value.toLowerCase()).SelectedValue;
     }

      this.requestData={ 
        GLPManagerPuid:glpManagerPuid.toUpperCase(),
        RequesterPuid:requesterPuid.toUpperCase(),
        BUCode:this.currentBreadcrumbItem.BUCode,
        BucketType:this.currentBreadcrumbItem.BucketType,
        BucketItemId:this.packagefolder.Id,
        PackageId:this.packagefolder.PackageId,
        Duration:this.folderPermissionForm.controls.Duration.value,
        Justification:this.folderPermissionForm.controls.Justification.value
      }
      this.spinnerService.show(true);
      this.requesterAccessService
      .CreatePackageFolderAccess(this.requestData)
      .pipe(
      map((res: boolean) => {
      if(res){
        this.getActivePermissionHolders({PackageId:this.packagefolder.PackageId,BucketItemId:this.packagefolder.Id,BucketType:this.currentBreadcrumbItem.BucketType,BUCode:this.currentBreadcrumbItem.BUCode});
        this.messageService.success(
        CommonConsants.PACKAGE_ACCESS_CREATED,
        this.appSettingService.toastrDisplayTime
        );
        this.accessGiven.emit(true);
      }
      }),
      catchError((error: HttpErrorResponse) => {
      if (error.error.detail !== undefined) {
      this.messageService.alert(
      error.error.detail,
      this.appSettingService.toastrDisplayTime
      );
      } else {
      this.messageService.alert(
      ErrorConstants.PACKAGE_ACCESS_CREATION_FAILED,
      this.appSettingService.toastrDisplayTime
      );
      }
      return throwError(() => new Error(error.message));
      }),
      finalize(()=>{
      this.spinnerService.show(false);
      })
      )
      .subscribe();
    }
  }
  scrollToTop(){
    this.el.nativeElement.scrollIntoView({behavior:'smooth',block:'start'});
  }
  
  showInformation(event :Event, item: Partial<IActivePermissionHoldersResponse>){
    let userInfo : IUserInformation = {Name:item.RequesterFullName,Email:item.RequesterEmailId,IsActiveUser:item.RequesterIsActiveUser};
    this.dataService.setUserInformation(userInfo);
    this.genericExtensions.onInfoClick(event, userInfo);
  }

  public buildFolderPermissionId(controlId: string): string {
    return `requester-access-form-${controlId}`;
  }
}
